import { ShieldAlert } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

/** Landing screen a suspended/expired tenant's users get redirected to —
 * see lib/api.js's response interceptor, which catches the 403
 * TENANT_SUSPENDED detail routes_auth.get_current_user sends from any
 * authenticated endpoint once an institution's subscription lapses or a
 * platform admin suspends it. Deliberately not gated by Protected/
 * AuthContext — a suspended user's own /auth/me call is itself blocked by
 * the same gate, so this page has to stand on its own without assuming
 * any of that context loaded successfully. */
export default function TenantSuspended() {
  const logout = () => {
    api.post("/auth/logout").catch(() => {}).finally(() => { window.location.href = "/login"; });
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center px-4 py-10" data-testid="tenant-suspended-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-slate-200/70 border border-slate-200 p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-red-100 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-red-600" />
        </div>
        <h1 className="font-display text-xl font-bold text-slate-900 mt-4">Workspace Suspended</h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed">
          This institutional workspace is currently suspended. For renewal and service restoration,
          please contact your university administrator or Wizard Software support.
        </p>
        <Button variant="outline" className="mt-6" onClick={logout} data-testid="tenant-suspended-logout">
          Sign out
        </Button>
      </div>
      <p className="text-center text-xs text-slate-400 mt-6">Powered by EduPulse Admissions</p>
    </div>
  );
}
